import React from 'react';
import style from '../../css/Part9.module.css'; // Adjust the path to your project

function FonePlusMembership() {
  return (
    <div className={style.container}>
      {/* Standard vs Premium Section */}
      <section className={style.comparisonSection}
        style={{
          background: `url('images/background/Rectangle 54.png') no-repeat center center`,
          backgroundSize: 'cover',
        }}
      >
        <h2>Standard vs Premium</h2>
        <div className={style.comparisonBackground}>
          <img src="images/background/foneplus schedule.png" alt="Standard vs Premium" className={style.comparisonImage} />
        </div>
      </section>
    </div>
  );
}

export default FonePlusMembership;
